import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { ConfigService } from '@ps-gui/shared-core';
import { DashboardConfig } from '@ps-gui/dashboard-shared-lib';

export const gutachtenGuard: CanActivateFn = () => {
  const configService = inject(ConfigService<DashboardConfig>);
  console.log('GUTACHTEN ENABLED: ', configService.config.gutachtenEnabled);
  return !!configService.config.gutachtenEnabled;
};
